import React from "react";

// Playful hand-drawn style decorative SVGs

export const SunBurst = ({ className = "", color = "#FFD166", size = 90 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 100 100" fill="none">
    <circle cx="50" cy="50" r="20" fill={color} />
    {Array.from({ length: 12 }).map((_, i) => {
      const a = (i * 30 * Math.PI) / 180;
      const x1 = 50 + Math.cos(a) * 28;
      const y1 = 50 + Math.sin(a) * 28;
      const x2 = 50 + Math.cos(a) * 40;
      const y2 = 50 + Math.sin(a) * 40;
      return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke={color} strokeWidth="5" strokeLinecap="round" />;
    })}
  </svg>
);

export const Squiggle = ({ className = "", color = "#4A90E2", width = 160 }) => (
  <svg className={className} width={width} height="20" viewBox="0 0 160 20" fill="none">
    <path d="M2 12 C 20 2, 30 2, 48 12 S 78 22, 96 12 S 126 2, 158 12" stroke={color} strokeWidth="4" strokeLinecap="round" />
  </svg>
);

export const Leaf = ({ className = "", color = "#84A98C", size = 40 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M4 20C4 12 10 4 20 4C20 14 14 20 4 20Z" fill={color} />
    <path d="M6 18C10 14 14 10 18 7" stroke="#fff" strokeWidth="1.4" strokeLinecap="round" opacity="0.7" />
  </svg>
);

export const Star = ({ className = "", color = "#FFD166", size = 34 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M12 2l2.6 6.3L21 9l-5 4.3L17.6 20 12 16.4 6.4 20 8 13.3 3 9l6.4-.7L12 2z" />
  </svg>
);

// Section wave divider
export const WaveTop = ({ color = "#FDFBF7", className = "" }) => (
  <svg className={className} viewBox="0 0 1440 80" preserveAspectRatio="none" style={{ display: "block", width: "100%", height: 60 }}>
    <path d="M0,40 C240,90 480,0 720,30 C960,60 1200,10 1440,40 L1440,80 L0,80 Z" fill={color} />
  </svg>
);
